<div class="container-fluid">
  <div class="row">
      <div class="col-md-12">
          <div class="card">
              <div class="card-header" style="padding-bottom: 5px !important">
                  <div >
                      <h5 class="pb-2">ملف طريقة التبرع</h5>
                  </div>
                  <ng-template >
                      
                  </ng-template>
              </div>
              <div class="card-body">
                  <form class="needs-validation" autocomplete="off" 
                  [formGroup]  = "PdfFileForm"
                  (ngSubmit)="onSubmit()" 
                  novalidate>
                      <div class="form-row">
               
            <!-- to insert image  -->
            <div class="col-12 my-3 " >
              <label for="validation03"><span class="validation-required">*</span> Pdf</label>
              <br>
              <!-- <img  style="width: 60%; height: 220px;" class="image-style p-2" /> -->
              <img  class="imgDiv curser"  src="../../../../assets/images/pdfImage.png"  height="140" width="140" (click)="OpenPdf(Pdf)" >

             <input type="file" accept="application/pdf" #file id="getPdf"
              style="display: none" (change)="getFileUrl($event)" />
          <button type="button" onclick="document.getElementById('getPdf').click()"
              class="btn  mt-3  d-block" >
              ارفاق ملف pdf
          </button>    
                      </div>
                      <button class="btn pull-right" type="submit">
                        تعديل
                    </button>
<!-- 
                      <ng-template #elseBlock>
                          <button [disabled]="button" class="btn  pull-right" type="submit">
                             حفظ
                          </button>
                          </ng-template> -->
                      <!-- <div *ngIf="update; else elseBlock">
                          <button class="btn pull-right" type="submit">
                              تعديل
                          </button>
                     </div> -->
                     </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
</div>

